<div class="form-container" >
  <div class="cardLayout">
    <ion-row>
      <ion-col size>
        <!-- <div class="formLabelSemiBoldfs16 mb-5">{{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement</div> -->
        <div class="formLabelSemiBoldfs16 mb-5">Termination Form </div>
      </ion-col>
      
      <ion-col size="auto" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>
    
    <mat-dialog-content class="p-0">
      <!-- authority-form.component.html -->
      <form [formGroup]="terminationForm">
        <ion-row>
          <ion-row>
            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">
                Employee Name<span class="red-cl">*</span>
              </div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select formControlName="employeeName" placeholder="Select Employee" (selectionChange)="onEmployeeChange($event)" style="color:black" [disabled]="updateEmployeeData!=null">
                  <mat-option *ngFor="let emp of userList" [value]="emp.id">
                    {{ emp.firstName }} {{emp.lastName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ion-col>
            
            
            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Employee Band<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="employeeBand" placeholder="type here"      style="color:black" />
              </mat-form-field>
            </ion-col>
            
            
            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Employee Grade<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="employeeGrade" placeholder="type here"      style="color:black" />
              </mat-form-field>
            </ion-col>
            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Employee Department<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="employeeDepartment" placeholder="type here"      style="color:black" />
              </mat-form-field>
            </ion-col>
            
            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Employee designation<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="employeeDesignation" placeholder="type here"      style="color:black" />
              </mat-form-field>
            </ion-col>
            
            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Date of Termination<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="terminationDate" placeholder="type here"      style="color:black" />
              </mat-form-field>
            </ion-col>
            
            
            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Termination Reason<span class="red-cl">*</span></div>
              
              <textarea  class="edittextarea w-100 mat-height40 mat-input-style" formControlName="terminationReason"  [readonly]="checkType=='notHR'"></textarea>
              <mat-error *ngIf="hasError('terminationReason', 'required')">termination reason is required</mat-error>
                 <mat-error class="formLabelRegularfs12" *ngIf="hasError('terminationReason', 'maxlength') ">
                Maximum 255 characters allowed
              </mat-error>
            </ion-col>
            
            <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">Last working date<span class="red-cl">*</span></div>
              <mat-form-field class="w-100 mat-height40 mat-input-style" >
                <input matInput [matDatepicker]="picker" formControlName="lastWorkingDate" placeholder="Select date"[min]="todayDate" [readonly]="checkType=='notHR'"  [readonly]="true"/>
                <mat-datepicker-toggle matSuffix [for]="picker"[disabled]="checkType === 'notHR'" ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="hasError('lastWorkingDate', 'required')">Last working date is required</mat-error>
              </mat-form-field>
            </ion-col>
              <ion-col size="12" size-md="6" size-lg="4" class="mt-10">
              <div class="formLabelRegularfs16 mb-5">
                Personal Mail ID <span class="red-cl">*</span>
              </div>

              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="personalMailId" placeholder="Enter your personal email" type="email"
                  style="color: black" [readonly]="checkType=='notHR'" />
              </mat-form-field>

              <mat-error class="formLabelRegularfs12" *ngIf="terminationForm.get('personalMailId')?.hasError('required')">
                Personal email is required
              </mat-error>
              <mat-error class="formLabelRegularfs12" *ngIf="terminationForm.get('personalMailId')?.hasError('email')">
                Please enter a valid email address
              </mat-error>
            </ion-col>
          </ion-row>
          
          
        </ion-row>
        
        <ion-row>
          <ion-col size="12" class="text-right mt-10">
            <button type="button" class="add_btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName"[class.disabled]="terminationForm.invalid ||isSubmitting" (click)="onSubmit()" [hidden]="checkType=='notHR'">Save</button>
            <button class="back_btn fs-14 fs_12ForMobile ml-10" (click)="onCancel()">Cancel</button>
          </ion-col>
        </ion-row>
      </form>
    </mat-dialog-content>
    
  </div>
</div>